
function Exclamation() {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512.000000 512.000000"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
        stroke="currentColore"
        strokeWidth="100"
      >
        <path
        stroke="currentColor"
          d="M1145 4935 l-25 -24 0 -604 0 -604 -72 -28 c-445 -172 -761 -539
            -860 -998 -29 -136 -32 -398 -5 -530 95 -472 412 -847 865 -1022 l72 -28 0
            -284 0 -284 25 -24 24 -25 376 0 375 0 0 -135 c0 -131 1 -137 25 -160 l24 -25
            1471 0 1471 0 24 25 25 24 0 2191 0 2191 -25 24 -24 25 -490 0 -489 0 -127
            138 c-70 75 -138 147 -152 160 l-24 22 -1230 0 -1230 0 -24 -25z m2375 -630
            l0 -496 25 -24 24 -25 456 0 455 0 0 -1560 0 -1560 -382 2 -381 3 -12 50 c-23
            104 -48 133 -524 609 l-459 459 33 72 c40 88 77 202 101 315 25 115 25 379 1
            500 -111 554 -536 980 -1084 1086 -96 19 -325 25 -430 11 l-63 -8 0 531 0 530
            1120 0 1120 0 0 -495z m521 -20 c167 -182 310 -338 318 -348 13 -16 -5 -17
            -333 -17 l-346 0 0 377 0 378 28 -30 c16 -17 166 -179 333 -360z m759 -1885
            l0 -2080 -596 0 -595 0 25 33 c14 18 35 54 46 80 l21 47 445 0 445 0 24 25 25
            24 0 1671 0 1671 -222 241 c-123 133 -249 271 -282 305 l-58 63 361 0 361 0 0
            -2080z m-3020 1171 c414 -94 750 -399 879 -798 44 -138 56 -215 56 -373 0 -83
            -6 -175 -14 -215 -97 -488 -450 -848 -943 -962 -101 -23 -373 -23 -476 0 -489
            111 -847 476 -943 962 -21 103 -18 349 5 455 76 352 299 650 610 816 135 71
            261 112 431 138 68 10 312 -4 395 -23z m1757 -2871 c53 -113 4 -252 -111 -312
            -57 -30 -155 -31 -211 -1 -23 12 -230 212 -478 461 l-438 439 55 42 c71 53
            184 166 237 237 l42 55 444 -443 c247 -247 450 -458 460 -478z m-1102 220
            l280 -280 -718 0 -717 0 0 210 0 211 63 -8 c93 -12 322 -9 407 6 90 16 262 71
            345 111 33 15 60 29 60 29 0 1 126 -125 280 -279z m520 -520 l80 -80 -478 0
            -477 0 0 80 0 80 398 0 397 0 80 -80z"
        />
        <path d="M1600 4480 l0 -80 240 0 240 0 0 80 0 80 -240 0 -240 0 0 -80z" />
        <path d="M2320 4480 l0 -80 480 0 480 0 0 80 0 80 -480 0 -480 0 0 -80z" />
        <path d="M1600 4080 l0 -80 840 0 840 0 0 80 0 80 -840 0 -840 0 0 -80z" />
        <path d="M2880 3440 l0 -80 720 0 720 0 0 80 0 80 -720 0 -720 0 0 -80z" />
        <path d="M2880 3040 l0 -80 720 0 720 0 0 80 0 80 -720 0 -720 0 0 -80z" />
        <path d="M3040 2640 l0 -80 640 0 640 0 0 80 0 80 -640 0 -640 0 0 -80z" />
        <path d="M3040 2240 l0 -80 160 0 160 0 0 80 0 80 -160 0 -160 0 0 -80z" />
        <path d="M3520 2240 l0 -80 400 0 400 0 0 80 0 80 -400 0 -400 0 0 -80z" />
        <path
          d="M1345 3424 c-445 -79 -776 -416 -851 -866 -54 -326 60 -666 303 -901
          87 -85 142 -124 252 -181 296 -152 634 -153 936 -3 104 51 193 118 280 209 89
          92 132 152 182 253 150 302 149 640 -3 936 -58 112 -97 167 -185 257 -238 243
          -583 355 -914 296z m325 -158 c184 -33 336 -113 470 -246 297 -298 344 -748
          114 -1102 -117 -182 -305 -314 -530 -374 -103 -27 -312 -26 -419 3 -413 112
          -685 482 -662 898 25 428 335 763 767 828 58 9 190 5 260 -7z"
        />
      </g>
    </svg>
  );
}

export default Exclamation;
